import * as t from '../../actionTypes';
import mapUserSearchResults from './userResultMapper';

const mapSingleUserData = users =>
  users.reduce((acc, user) => {
    const newUser = {
      userId: user._id,
      userName: user.userName,
      ...(user.userEmail ? { email: user.userEmail } : {}),
      ...(user.firstName ? { firstName: user.firstName } : {}),
      ...(user.lastName ? { lastName: user.lastName } : {}),
      ...(user.lastLogin ? { lastLogin: user.lastLogin } : {}),
      ...(user.failedLogins ? { failedLogins: user.failedLogins } : {})
    };
    return { ...acc, ...newUser };
  }, {});

export const initialState = {
  errorOccurred: false,
  success: false,
  loading: false,
  loadingSingleUser: false,
  userSearchResults: [],
  userSearchTotal: 0,
  singleUser: {},
  error: '',
  showResetPasswordPanel: false,
  passwordRequestWasSent: false
};

export default function userConsole(state = initialState, action) {
  switch (action.type) {
    case t.SEARCH_USER_FOR_CONSOLE:
      return {
        ...state,
        loading: true
      };
    case t.STOP_USER_SEARCH_FOR_CONSOLE:
      return {
        ...state,
        loading: false
      };
    case t.SET_USER_SEARCH_RESULT_FOR_CONSOLE:
      return {
        ...state,
        loading: false,
        errorOccurred: false,
        userSearchResults: mapUserSearchResults(action.data.success.users),
        userSearchTotal: action.data.success.total
      };
    case t.SET_USER_SEARCH_ERROR_FOR_CONSOLE:
      return {
        ...state,
        loading: false,
        errorOccurred: true
      };
    case t.EMPTY_USER_SEARCH_RESULTS_FOR_CONSOLE:
      return {
        ...state,
        userSearchResults: [],
        userSearchTotal: 0
      };

    case t.SEARCH_SINGLE_USER_FOR_CONSOLE:
      return {
        ...state,
        loadingSingleUser: true
      };
    case t.SEARCH_SINGLE_USER_FOR_CONSOLE_SUCCESS:
      return {
        ...state,
        loadingSingleUser: false,
        singleUser: mapSingleUserData(action.data.users)
      };
    case t.SEARCH_SINGLE_USER_FOR_CONSOLE_FAIL:
      return {
        ...state,
        loadingSingleUser: false,
        error: action.error
      };

    case t.OPEN_RESET_PASSWORD_PANEL:
      return {
        ...state,
        showResetPasswordPanel: true
      };
    case t.CLOSE_RESET_PASSWORD_PANEL:
      return {
        ...state,
        showResetPasswordPanel: false
      };

    case t.REQUEST_PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        showResetPasswordPanel: false,
        passwordRequestWasSent: true
      };
    case t.REQUEST_PASSWORD_RESET_FAILED:
      return {
        ...state,
        error: action.error,
        showResetPasswordPanel: false,
        passwordRequestWasSent: true
      };
    case t.SET_PASSWORD_REQUEST_SENT_VALUE:
      return {
        ...state,
        passwordRequestWasSent: action.data
      };
    default:
      return state;
  }
}
